import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import update from 'immutability-helper'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import {
  fetchRider,
  editRider,
  shareRider,
  removeRiderShare,
  exportRider,
  deleteRider
} from '../actions/rider'

import {
  addRiderContact,
  removeRiderContact,
  createRiderContact,
  editRiderContact,
  deleteRiderContact
} from '../actions/rider-contact'

import {
  addRiderMember,
  removeRiderMember,
  createRiderMember,
  editRiderMember,
  moveRiderMember,
  deleteRiderMember
} from '../actions/rider-member'

import {
  addRiderColumn,
  removeRiderColumn,
  createRiderColumn,
  moveRiderColumn,
  deleteRiderColumn
} from '../actions/rider-column'

import {
  addRiderItem,
  removeRiderItem,
  createRiderItem,
  createRiderItems,
  cloneRiderItem,
  editRiderItem,
  moveRiderItem,
  deleteRiderItem,
  deleteRiderItemGroup
} from '../actions/rider-item'

import {
  createRiderStageplan,
  editRiderStageplan,
  deleteRiderStageplan
} from '../actions/rider-stageplan'

import {
  addRiderStageplanItem,
  removeRiderStageplanItem,
  createRiderStageplanItem,
  editRiderStageplanItem,
  deleteRiderStageplanItem
} from '../actions/rider-stageplan-item'

import {
  fetchStageElements,
  createStageElement,
  getAvailableEquipmentTypes,
  getSearchResults
} from '../actions/stage-elements'

import {
  setAlert
} from '../actions/alerts'

import { setModal } from '../actions/modal'

import Loading from '../components/common/loading'
import NotFound from '../components/common/not-found'
import Login from '../containers/login'

import RiderNavigation from '../components/rider/rider-navigation'
import RiderContacts from '../components/rider/rider-contacts/contacts'
import RiderGeneral from '../components/rider/rider-general/general'
import RiderHospitality from '../components/rider/rider-hospitality/hospitality'
import RiderInput from '../components/rider/rider-input/input'
import RiderMembers from '../components/rider/rider-members/members'
import RiderOutput from '../components/rider/rider-output/output'
import RiderRequirements from '../components/rider/rider-requirements/requirements'
import RiderStageplans from '../components/rider/rider-stageplans/stageplans'
// import RiderEmbedSharing from '../components/rider/rider-embed-sharing'

const sections = [
  {
    title: 'General',
    slug: 'general'
  },
  {
    title: 'Members',
    slug: 'members'
  },
  {
    title: 'Requirements',
    slug: 'requirements'
  },
  {
    title: 'Input List',
    slug: 'input'
  },
  {
    title: 'Output List',
    slug: 'output'
  },
  {
    title: 'Stage Plan',
    slug: 'stageplan'
  },
  {
    title: 'Hospitality',
    slug: 'hospitality'
  },
  {
    title: 'Contacts',
    slug: 'contacts'
  }
]

class Rider extends Component {
  constructor(props) {
    super(props)

    this.state = {
      activeSection: undefined,
      activeSectionTimeout: undefined
    }

    sections.forEach(section => this[section.slug] = React.createRef())
  }

  componentWillMount() {
    const { riderId } = this.props.match.params

    if (riderId) this.props.fetchRider(riderId)
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll)
  }

  componentWillReceiveProps(nextProps) {
    const { rider } = nextProps

    if (rider.deletedRiderId) this.props.history.replace({pathname: '/library'})

    if (rider.createChildren && rider.createChildren !== this.props.rider.createChildren) {
      if (rider.createChildren.length > 0) {
        const { createChildren } = rider

        createChildren.forEach((item, index) => { // TODO: Replace with createMultiItem call
          if (item.id) {
            this.props.editRiderItem(rider.id, item)
          } else {
            this.props.createRiderItem(rider.id, item)
          }
        })
      }
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { rider, stageElements, match } = nextProps

    if (rider !== this.props.rider) return true
    if (stageElements !== this.props.stageElements) return true
    if (match.params !== this.props.match.params) return true
    if (nextState !== this.state) return true
    return false
  }

  componentWillUpdate(nextProps, nextState) {
    const { rider, stageElements } = nextProps
    const { activeSectionTimeout } = nextState

    if (Object.keys(rider).length > 0 && rider.isFetching !== true && rider.editable && !rider.error) {
      if (Object.keys(stageElements).length === 0) {
        this.props.fetchStageElements()
      }
    }

    if (activeSectionTimeout !== this.state.activeSectionTimeout) clearTimeout(this.state.activeSectionTimeout)
  }

  componentDidUpdate(prevProps, prevState) {
    const { rider } = this.props
    const { riderId, section } = this.props.match.params
    const { activeSection } = this.state

    if (rider.isFetching !== true && prevProps.rider.isFetching === true) {
      this.setState({activeSection: section || 'general'}, () => this.scrollTo(section, 'auto'))
    }

    if (rider.isFetching !== true && activeSection !== prevState.activeSection) {
      const activeSectionTimeout = setTimeout(() => this.props.history.replace({pathname: `/rider/${riderId}/${activeSection}`}), 500)

      this.setState({activeSectionTimeout})
    }

    window.addEventListener('scroll', this.handleScroll)
  }

  componentWillUnmount() {
    if (this.state.activeSectionTimeout) clearTimeout(this.state.activeSectionTimeout)

    window.removeEventListener('scroll', this.handleScroll)
  }

  handleScroll = () => {
    const { rider } = this.props
    const { section } = this.props.match.params
    const { scrollTop } = document.documentElement

    let activeSection = undefined

    sections.every(section => {
      const domElement = this[section.slug] && ReactDOM.findDOMNode(this[section.slug].current)
      const offsetTop = domElement ? domElement.offsetTop : 0

      if (scrollTop >= offsetTop) {
        activeSection = section.slug

        return true
      }

      return false
    })

    if (rider.isFetching !== true && activeSection && activeSection !== section) this.setState({activeSection})
  }

  scrollTo(section, behavior) {
    const domElement = this[section] && ReactDOM.findDOMNode(this[section].current)
    const offsetTop = domElement ? domElement.offsetTop : 0

    window.scroll({
      top: offsetTop,
      behavior
    })
  }

  renderExportModal() {
    const { rider } = this.props

    if (rider.isExporting !== true) return null

    return (
      <div className="modal">
        <div className="modal-escape" />

        <div className="modal-content">
          <Loading
            className="rider-export"
            message="We are exporting your rider" />
        </div>
      </div>
    )
  }

  render() {
    const { userSession, rider, stageElements } = this.props
    const { section } = this.props.match.params

    if (rider.error) {
      return rider.error.code === 403
        ? <Login />
        : <NotFound />
    } else
    if (Object.keys(rider).length === 0 || rider.isFetching === true) return (
      <Loading
        className="rider"
        message="We are loading up your rider" />
    )

    const view = {
      loggedIn: userSession.loggedIn,
      editable: rider.editable,
      sharing: rider.sharing
    }

    return (
      <div className="rider">
        {this.renderExportModal()}

        <RiderNavigation
          sections={sections}
          riderId={rider.id}
          activeSection={this.state.activeSection}
          scrollTo={(section) => this.scrollTo(section, 'smooth')} />

        <div className="rider-document">
          <RiderGeneral ref={this.general}
            view={view}
            title={rider.title}
            description={rider.description}
            publicSharing={rider.public}
            linkSharing={rider.link_sharing}
            shares={rider.shares}
            editRider={(data) => this.props.editRider(rider.id, data)}
            shareRider={(email) => this.props.shareRider(rider.id, email)}
            removeRiderShare={(shareId) => this.props.removeRiderShare(shareId)}
            deleteRider={() => this.props.deleteRider(rider.id)}
            exportPDF={(selector) => this.props.exportRider(selector)} />

          <RiderMembers ref={this.members}
            view={view}
            artist={rider.artist}
            members={rider.members}
            items={rider.items}
            availableItems={rider.availableItems}
            editRider={(data) => this.props.editRider(rider.id, data)}
            createRiderItem={(item) => this.props.createRiderItem(rider.id, {
              group: 'input',
              class: item.type.slug === 'drums' ? 'instrument-group' : 'instrument',
              title: item.title,
              type: item.type.slug,
              member: item.member
            })}
            addRiderMember={(member) => this.props.addRiderMember(member)}
            removeRiderMember={(index) => this.props.removeRiderMember(index)}
            createRiderMember={(member) => this.props.createRiderMember(rider.id, member)}
            editRiderMember={(member) => this.props.editRiderMember(member)}
            moveRiderMember={({id, position}) => this.props.moveRiderMember(id, position)}
            deleteRiderMember={(member) => this.props.deleteRiderMember(member)}
            stageElements={stageElements}
            getSearchResults={(array, term) => this.props.getSearchResults(array, term)}
            setAlert={({message, link}) => this.props.setAlert(message, link)} />

          <div className="page-break" />

          <RiderRequirements ref={this.requirements}
            view={view}
            rider={rider}
            addRiderItem={(item) => this.props.addRiderItem(item)}
            removeRiderItem={(item) => this.props.removeRiderItem(item)}
            createRiderItem={(item) => this.props.createRiderItem(rider.id, item)}
            editRiderItem={(item) => this.props.editRiderItem(rider.id, item)}
            moveRiderItem={({id, position}) => this.props.moveRiderItem(id, position)}
            deleteRiderItem={(id) => this.props.deleteRiderItem(id)}
            setModal={(name, data) => this.props.setModal(name, data)} />

          <div className="page-break" />

          <RiderInput ref={this.input}
            view={view}
            group="input"
            rider={{
              id: rider.id,
              items: rider.input,
              itemGroups: rider.itemGroups,
              columns: rider.columns,
              // editable: rider.editable
            }}
            addRiderColumn={(column) => {
              this.props.getAvailableEquipmentTypes(stageElements.equipmentTypes, rider.columns)
              this.props.addRiderColumn(column)
            }}
            removeRiderColumn={(index) => this.props.removeRiderColumn(index)}
            createRiderColumn={(column) => this.props.createRiderColumn(rider.id, column)}
            moveRiderColumn={(column) => this.props.moveRiderColumn(column)}
            deleteRiderColumn={(id) => this.props.deleteRiderColumn(id)}
            stageElements={stageElements}
            createStageElement={(stageElement) => this.props.createStageElement(stageElement)}
            getSearchResults={(array, term) => this.props.getSearchResults(array, term)}
            addRiderItem={(item) => this.props.addRiderItem({...item, group: 'input'})}
            removeRiderItem={(item) => this.props.removeRiderItem({...item, group: 'input'})}
            createRiderItem={(item) => this.props.createRiderItem(rider.id, item)}
            createRiderItems={(parent, items) => this.props.createRiderItems(rider.id, parent, items)}
            editRiderItem={(item) => this.props.editRiderItem(rider.id, item)}
            moveRiderItem={({id, position}) => this.props.moveRiderItem(id, position)}
            deleteRiderItem={(id) => this.props.deleteRiderItem(id)}
            setModal={(name, data) => this.props.setModal(name, data)} />

          <div className="page-break" />

          <RiderOutput ref={this.output}
            view={view}
            group="output"
            rider={{
              id: rider.id,
              items: rider.output,
              // itemGroups: rider.itemGroups,
              input: rider.input,
              columns: rider.output,
              // editable: rider.editable,
              members: rider.members
            }}
            moveRiderColumn={(column) => this.props.moveRiderColumn(column)}
            stageElements={stageElements}
            createStageElement={(stageElement) => this.props.createStageElement(stageElement)}
            getSearchResults={(array, term) => this.props.getSearchResults(array, term)}
            addRiderItem={(item) => this.props.addRiderItem(item)}
            removeRiderItem={(item) => this.props.removeRiderItem(item)}
            createRiderItem={(item) => this.props.createRiderItem(rider.id, item)}
            createRiderItems={(item) => {
              const parentItem = update(item, {
                $merge: {
                  type: item.type,
                  group: 'output',
                  class: 'monitor-group',
                  member: item.member,
                  value: item.value
                }
              })

              const childItem = update(item, {
                $merge: {
                  type: item.type,
                  group: 'output',
                  class: 'monitor'
                }
              })

              this.props.createRiderItems(rider.id, parentItem, [childItem, childItem])
            }}
            cloneRiderItem={(item) => {
              const parentItem = {
                type: item.type,
                group: 'output',
                class: 'monitor-group',
                position: item.position,
                title: item.title,
                member: (item.member && item.member.id),
                value: item.value
              }

              this.props.cloneRiderItem(rider.id, {
                parent_create: parentItem,
                parent: null,
                clone_item: item.id,
                clone_count: 2,
                delete_cloned: true
              })
            }}
            editRiderItem={(item) => this.props.editRiderItem(rider.id, item)}
            moveRiderItem={({id, position}) => this.props.moveRiderItem(id, position)}
            deleteRiderItem={(id) => this.props.deleteRiderItem(id)}
            deleteRiderItemGroup={(item) => this.props.deleteRiderItemGroup(item)}
            setModal={(name, data) => this.props.setModal(name, data)} />

          <div className="page-break" />

          <RiderStageplans ref={this.stageplan}
            view={view}
            stageplans={rider.stageplans}
            categories={{
              members: rider.members,
              instruments: rider.input,
              monitors: rider.output,
              misc: stageElements.stageplanItems
            }}
            createRiderStageplan={(stageplan) => this.props.createRiderStageplan(rider.id, stageplan)}
            editRiderStageplan={(stageplan) => this.props.editRiderStageplan(stageplan)}
            deleteRiderStageplan={(id) => this.props.deleteRiderStageplan(id)}
            addRiderStageplanItem={(item) => this.props.addRiderStageplanItem(item)}
            removeRiderStageplanItem={(index) => this.props.removeRiderStageplanItem(index)}
            createRiderStageplanItem={(id, item) => this.props.createRiderStageplanItem(id, item)}
            editRiderStageplanItem={(item, index) => this.props.editRiderStageplanItem(item, index)}
            deleteRiderStageplanItem={(id, index) => this.props.deleteRiderStageplanItem(id, index)} />

          <div className="page-break" />

          <RiderHospitality ref={this.hospitality}
            view={view}
            rider={rider}
            addRiderItem={(item) => this.props.addRiderItem(item)}
            removeRiderItem={(item) => this.props.removeRiderItem(item)}
            createRiderItem={(item) => this.props.createRiderItem(rider.id, item)}
            editRiderItem={(item) => this.props.editRiderItem(rider.id, item)}
            moveRiderItem={({id, position}) => this.props.moveRiderItem(id, position)}
            deleteRiderItem={(id) => this.props.deleteRiderItem(id)}
            setModal={(name, data) => this.props.setModal(name, data)} />

          <div className="page-break" />

          <RiderContacts ref={this.contacts}
            view={view}
            contacts={rider.contacts}
            addRiderContact={(contact) => this.props.addRiderContact(contact)}
            removeRiderContact={(index) => this.props.removeRiderContact(index)}
            createRiderContact={(contact) => this.props.createRiderContact(rider.id, contact)}
            editRiderContact={(contact) => this.props.editRiderContact(contact)}
            deleteRiderContact={(contact) => this.props.deleteRiderContact(contact)} />

          {/*<RiderEmbedSharing
            isEditable={rider.editable}
            rider={rider}
            editRider={(data) => this.props.editRider(rider.id, data)}
            setModal={(name, data) => this.props.setModal(name, data)} />*/}
        </div>
      </div>
    )
  }
}

Rider.propTypes = {
  match: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  userSession: PropTypes.object,
  rider: PropTypes.object,
  fetchRider: PropTypes.func,
  editRider: PropTypes.func,
  shareRider: PropTypes.func,
  removeRiderShare: PropTypes.func,
  exportRider: PropTypes.func,
  deleteRider: PropTypes.func,
  addRiderContact: PropTypes.func,
  removeRiderContact: PropTypes.func,
  createRiderContact: PropTypes.func,
  editRiderContact: PropTypes.func,
  deleteRiderContact: PropTypes.func,
  addRiderMember: PropTypes.func,
  removeRiderMember: PropTypes.func,
  createRiderMember: PropTypes.func,
  editRiderMember: PropTypes.func,
  moveRiderMember: PropTypes.func,
  deleteRiderMember: PropTypes.func,
  addRiderColumn: PropTypes.func,
  removeRiderColumn: PropTypes.func,
  createRiderColumn: PropTypes.func,
  moveRiderColumn: PropTypes.func,
  addRiderItem: PropTypes.func,
  removeRiderItem: PropTypes.func,
  createRiderItem: PropTypes.func,
  createRiderItems: PropTypes.func,
  cloneRiderItem: PropTypes.func,
  editRiderItem: PropTypes.func,
  moveRiderItem: PropTypes.func,
  deleteRiderItem: PropTypes.func,
  deleteRiderItemGroup: PropTypes.func,
  stageplans: PropTypes.array,
  createRiderStageplan: PropTypes.func,
  editRiderStageplan: PropTypes.func,
  deleteRiderStageplan: PropTypes.func,
  addRiderStageplanItem: PropTypes.func,
  removeRiderStageplanItem: PropTypes.func,
  createRiderStageplanItem: PropTypes.func,
  editRiderStageplanItem: PropTypes.func,
  deleteRiderStageplanItem: PropTypes.func,
  stageElements: PropTypes.object,
  fetchStageElements: PropTypes.func,
  createStageElement: PropTypes.func,
  getAvailableEquipmentTypes: PropTypes.func,
  getSearchResults: PropTypes.func,
  setModal: PropTypes.func
}

Rider.defaultProps = {
  match: {},
  location: {},
  history: {},
  userSession: {},
  rider: {},
  fetchRider: function() {},
  editRider: function() {},
  shareRider: function() {},
  removeRiderShare: function() {},
  exportRider: function() {},
  deleteRider: function() {},
  addRiderContact: function() {},
  removeRiderContact: function() {},
  createRiderContact: function() {},
  editRiderContact: function() {},
  deleteRiderContact: function() {},
  addRiderMember: function() {},
  removeRiderMember: function() {},
  createRiderMember: function() {},
  editRiderMember: function() {},
  moveRiderMember: function() {},
  deleteRiderMember: function() {},
  addRiderColumn: function() {},
  removeRiderColumn: function() {},
  createRiderColumn: function() {},
  moveRiderColumn: function() {},
  deleteRiderColumn: function() {},
  addRiderItem: function() {},
  removeRiderItem: function() {},
  createRiderItem: function() {},
  createRiderItems: function() {},
  cloneRiderItem: function() {},
  editRiderItem: function() {},
  moveRiderItem: function() {},
  deleteRiderItem: function() {},
  deleteRiderItemGroup: function() {},
  stageplans: [],
  createRiderStageplan: function() {},
  editRiderStageplan: function() {},
  deleteRiderStageplan: function() {},
  addRiderStageplanItem: function() {},
  removeRiderStageplanItem: function() {},
  createRiderStageplanItem: function() {},
  editRiderStageplanItem: function() {},
  deleteRiderStageplanItem: function() {},
  stageElements: {},
  fetchStageElements: function() {},
  createStageElement: function() {},
  getAvailableEquipmentTypes: function() {},
  getSearchResults: function() {},
  setModal: function() {}
}

export const mapStateToProps = (state) => {
  return {
    rider: state.rider,
    stageElements: state.stageElements
  }
}

export const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    fetchRider,
    editRider,
    shareRider,
    removeRiderShare,
    exportRider,
    deleteRider,
    addRiderContact,
    removeRiderContact,
    createRiderContact,
    editRiderContact,
    deleteRiderContact,
    addRiderMember,
    removeRiderMember,
    createRiderMember,
    editRiderMember,
    moveRiderMember,
    deleteRiderMember,
    addRiderColumn,
    removeRiderColumn,
    createRiderColumn,
    moveRiderColumn,
    deleteRiderColumn,
    addRiderItem,
    removeRiderItem,
    createRiderItem,
    createRiderItems,
    cloneRiderItem,
    editRiderItem,
    moveRiderItem,
    deleteRiderItem,
    deleteRiderItemGroup,
    createRiderStageplan,
    editRiderStageplan,
    deleteRiderStageplan,
    addRiderStageplanItem,
    removeRiderStageplanItem,
    createRiderStageplanItem,
    editRiderStageplanItem,
    deleteRiderStageplanItem,
    createStageElement,
    fetchStageElements,
    getAvailableEquipmentTypes,
    getSearchResults,
    setModal,
    setAlert
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Rider)



// WEBPACK FOOTER //
// ./src/containers/rider.js